export default "__VITE_ASSET__DC_gl1Q7__"